import React from "react";
import "./Modal.css";
import Modal from "react-bootstrap/Modal";
const Modals = (props) => {
  const handleClose = () => {
    props.setshow(false);
  };
  return (
    <>
      <Modal className="myModal" show={props.Show} onHide={handleClose}>
        <Modal.Body>
          <div className="modalwrapper">
            <span className="Modalheading">Invite a New Admin</span>
            <div className="modalInput">
              <input type="text" placeholder="Your Email" />
              <button>Invite</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Modals;
